module.exports = __webpack_public_path__ + "static/media/check-mark.952a41f6.svg";